import { RichText } from '@graphcommerce/graphcms-ui'
import { Fab, Overlay } from '@graphcommerce/next-ui'
import { Container } from '@mui/material'
import React from 'react'
import { ConfiguratorQuestionFragment } from '../../graphql/configurator/ConfiguratorQuestion.gql'
import { OverlayHeader } from '../Overlay/OverlayHeader'
import iconQuestionmark from './questionmark.svg'

type ConfiguratorQuestionExplanationProps = {
  explanation: ConfiguratorQuestionFragment['explanation']
  title: string
}

export function ConfiguratorQuestionExplanation(props: ConfiguratorQuestionExplanationProps) {
  const { explanation, title } = props

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const isOpen = Boolean(anchorEl)

  if (!explanation?.raw?.children) return null

  return (
    <>
      <Fab
        size='small'
        icon={iconQuestionmark}
        aria-controls={isOpen ? 'explanation-overlay' : undefined}
        aria-expanded={isOpen}
        aria-label='Toggle explanation'
        sx={(theme) => ({
          boxShadow: theme.shadows[8],
          width: '32px',
          height: '32px',
          minHeight: '32px',
          position: 'absolute',
          right: theme.spacings.sm,
          top: theme.spacings.sm,
          '& .IconSvg': { stroke: theme.palette.primary.main },
        })}
        onClick={(e) => {
          e.preventDefault()
          handleClick(e)
        }}
      />
      <Overlay
        key={explanation?.raw}
        active={isOpen}
        onClosed={handleClose}
        sizeSm='minimal'
        sizeMd='minimal'
        variantSm='bottom'
        variantMd='bottom'
      >
        <>
          <OverlayHeader onClose={handleClose}>{title}</OverlayHeader>
          <Container maxWidth='md' sx={(theme) => ({ py: theme.spacings.sm })}>
            <RichText
              raw={explanation.raw}
              sxRenderer={{
                'heading-three': (theme) => ({ color: theme.palette.primary.main }),
                image: (theme) => ({ '& img': { borderRadius: theme.shape.borderRadius } }),
              }}
            />
          </Container>
        </>
      </Overlay>
    </>
  )
}
